import { EventEmitter } from '@angular/core';
import { Component, OnInit, Input, Output } from '@angular/core';
import { ExpandedPanel } from 'src/app/models/in-out-panel/expanded-panel-object.model';
import { OptionIcons } from 'src/app/models/in-out-panel/option-icons-object.model';

@Component({
  selector: 'app-characteristics-icons',
  templateUrl: './characteristics-icons.component.html',
  styleUrls: ['./characteristics-icons.component.css']
})
export class CharacteristicIconsComponent implements OnInit {

  @Input() expanded: boolean;
  @Output() expandEvent = new EventEmitter();

  expandedIcons;
  noExpandedIcons;

  expandedPanelState: ExpandedPanel;

  constructor() {

  }

  ngOnInit() {

    const copyAll = new OptionIcons('file_copy', 'Copiar todas', this.notImplementYet);
    const copyAllAsJson = new OptionIcons('file_copy', 'Copiar todas como JSON', this.notImplementYet);
    const expandPanel = new OptionIcons('zoom_out_map', 'Expandir panel', this.expandPanels.bind(this));
    const matchPanels = new OptionIcons('settings_ethernet', 'Igualar paneles', this.contractPanels.bind(this));
    this.expandedIcons = [copyAll, copyAllAsJson, matchPanels];
    this.noExpandedIcons = [copyAll, copyAllAsJson, expandPanel];
  }

  notImplementYet(): any {
  }

  public contractPanels() {
    this.expandEvent.emit(false);
  }

  public expandPanels() {
    this.expandEvent.emit(true);
  }


}
